import ApiService from "../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/student/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveStudent: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/roommember/addroommember", vo, successCallback, failureCallback);
    }
};

export default EditService;
